<template>
  <VWidget
    v-if="item.type === 'coupon'"
    :title="$t('Coupon')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
        >
          <v-text-field
            :error-messages="item.displayErrors('code')"
            v-model="item.code"
            :label="$t('Coupon code')"
            :hint="$t('For example HAPPYSALE2019')"
            outline
            persistent-hint
          />
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <v-text-field
            :error-messages="item.displayErrors('max_customer_uses')"
            v-model="item.max_customer_uses"
            :label="$t('Maximum uses per customer')"
            outline
          />

        </v-flex>
        <v-flex
          xs12
          md6
        >
          <v-text-field
            :error-messages="item.displayErrors('max_total_uses')"
            v-model="item.max_total_uses"
            :label="$t('Maximum total uses')"
            outline
          />
        </v-flex>
      </v-layout>

    </div>
  </VWidget>
</template>

<script>

export default {
  name: 'DiscountSingleCoupon',

  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
